import { render, staticRenderFns } from "./Subtitle.vue?vue&type=template&id=934d765a&functional=true&"
var script = {}
import style0 from "./Subtitle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports